import { useObserveEffect, useSelector } from '@legendapp/state/react';
import { TFLoadingOverlay, TFNotifier } from '@tf/ui';
import type React from 'react';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { useEntity } from '@/core/api/entities';
import { monitoringStore } from '@/core/stores';

interface Props extends React.PropsWithChildren {
	entityId: number;
}

export const MonitoringProvider: React.FC<Props> = ({ children, entityId }) => {
	const navigate = useNavigate();

	const entityQuery = useEntity(entityId);
	const selectedAccount = useSelector(() => monitoringStore.selected.get());

	useObserveEffect(() => {
		// @ts-expect-error FIXME TS error is suppressed for migration, fix it later
		monitoringStore.set({ hits: null, selected: null });
	});

	useEffect(() => {
		if (selectedAccount === null) {
			monitoringStore.selected.set(entityQuery.data || null);
		} else if (entityQuery.data) {
			// assign() merges a partial entity and its type never accepted null;
			// `|| null` only compiled because a looser @types resolution hid it.
			// There is nothing to merge when the query has no data, so skip.
			monitoringStore.selected.assign(entityQuery.data);
		}
	}, [entityQuery.data, selectedAccount]);

	useEffect(() => {
		if (entityQuery.error) {
			TFNotifier.error('Could not read the entity information. Please try again later');
			navigate('/monitoring');
		}
	}, [entityQuery.error, navigate]);

	if (selectedAccount === null) {
		return <TFLoadingOverlay label="Loading..." h={500} />;
	}

	return <>{children}</>;
};
